import React from "react";
import { createRoot } from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import { UserProvider } from "./context/UserContext";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

// =====================================================
// ROOT ELEMENT
// =====================================================

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "DfluxSpace: Root element with id='root' was not found."
  );
}

// =====================================================
// REACT ROOT
// =====================================================

const root = createRoot(rootElement);

// =====================================================
// APPLICATION PROVIDERS
// =====================================================
//
// Provider hierarchy:
//
// React.StrictMode
//      ↓
// HelmetProvider
//      ↓
// BrowserRouter
//      ↓
// UserProvider
//      ↓
// App
//
// HelmetProvider
// ----------------
// Provides application-wide support for:
//
// - Page titles
// - Meta descriptions
// - Canonical URLs
// - Open Graph metadata
// - Twitter metadata
// - Structured data
//
// BrowserRouter
// -------------
// Handles:
//
// /
// /about
// /contact
// /privacy-policy
// /terms
// /faq
// /dmca
// /sitemap
// /shorts
// /products
//
// English architecture:
//
// /en
// /en/:category
// /en/:category/:subcategory
// /en/:category/:subcategory/:slug
//
// UserProvider
// ------------
// Preserves the existing application/user state
// architecture.
// =====================================================

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <UserProvider>
          <App />
        </UserProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);